import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { Names } from '@ils/static/names.js';
import { sendTerminCreatedMail } from '../server/mails.js';
import { CalendarEvent } from './calendarEvent.js';

@Entity()
export class EvaluationTermin extends CalendarEvent {
  static override _class = Names.EvaluationTermin._class;
  static override _collectionName = Names.EvaluationTermin._collectionName;

  constructor(doc: PartialEntityData<EvaluationTermin>) {
    super(doc);
  }

  @Field(type => [String], { default: v => v ?? [] })
  slotIDs!: string[];

  @Field(type => Int)
  slotCount!: number;

  @validate(options => {
    if (options.value && options.value.length !== 0) return;
    throw new ValidationError('userIDs muss genau zwei Werte enthalten', { key: options.key });
  })
  @Field(type => [String])
  override userIDs!: [string, string];

  // TODO: move to scheduler
  static override async afterCreate(entity: MongoEntity, result: any) {
    await super.afterCreate(entity, result);
    await sendTerminCreatedMail(entity._id);
  }
}
